import { CLEAR_ALERT, SET_ALERT } from "../types";

export default (state, action) => {
    switch (action.type) {
        case SET_ALERT:
            return action.payload;
        case CLEAR_ALERT:
            return null;
        default:
            return state;
    }
};